import EditableRoundsTab from "./EditableRoundsTab"

export default function AssetDetectionTab({ assetId, active }: { assetId: number; active: boolean }) {
  return (
    <EditableRoundsTab
      assetId={assetId}
      active={active}
      contractType="ADA"
      emptyMessage="No asset detection rounds yet. Link this asset to a contract (ADA type) to create the first round."
    />
  )
}
